import { useAtom } from 'jotai';
import { useCallback, useEffect } from 'react';
import { useNavigateSystemError } from 'src/hooks/common/useNavigateSystemError';
import { globalDataStore, prsItemSettingsStateAtom } from 'src/jotai/atom';
import { getPrsItemSettings } from 'src/utilities/restApi/common/prsItemSettings';

export const usePrsItemSettings = () => {
  const [state, setState] = useAtom(prsItemSettingsStateAtom, { store: globalDataStore });
  const navigateSystemError = useNavigateSystemError();

  useEffect(() => {
    if (state.fetched || state.loading || state.error) return;

    setState((prev) => ({ ...prev, loading: true }));

    getPrsItemSettings()
      .then((res) => {
        const prsItemSettings = (res.data?.prsitem_settings ?? []).map((item) => ({
          prsItemKey: item.prsitemkey,
          displayFlg: item.displayflg,
        }));
        const additionalItemSettings = (res.data?.additionalitem_settings ?? []).map((item) => ({
          additionalItemIndex: item.additionalitemindex,
          additionalItemName: item.additionalitemname,
        }));

        setState({
          fetched: true,
          loading: false,
          error: false,
          prsItemSettings,
          additionalItemSettings,
        });
      })
      .catch(() => {
        setState((prev) => ({ ...prev, loading: false, error: true }));
        navigateSystemError();
      });
  }, [state.fetched, state.loading, state.error, setState, navigateSystemError]);

  const isVisible = useCallback(
    (prsItemKey: string): boolean => {
      if (!state.prsItemSettings) return false;
      return state.prsItemSettings.find((s) => s.prsItemKey === prsItemKey)?.displayFlg ?? false;
    },
    [state.prsItemSettings]
  );

  // アンマウント時に error をクリア（次回マウントで再取得）
  useEffect(() => {
    return () => {
      setState((prev) => (prev.error ? { ...prev, error: false } : prev));
    };
  }, [setState]);

  return {
    prsItemSettings: state.prsItemSettings,
    additionalItemSettings: state.additionalItemSettings,
    isVisible,
  };
};